type CurrencyConfig = { currency: string; currencyLocaleFormat: string };

function getCurrencySymbol(currency: string, locale: string): string {
  try {
    return new Intl.NumberFormat(locale, { style: "currency", currency })
      .formatToParts(0)
      .find((p) => p.type === "currency")?.value ?? currency.toUpperCase();
  } catch {
    return currency.toUpperCase();
  }
}

/**
 * @param amount - Amount in the smallest currency unit (e.g., cents)
 */
export function formatPrice(amount: number, config: CurrencyConfig): string {
  const a = Number((amount / 100).toFixed(2));

  try {
    return new Intl.NumberFormat(config.currencyLocaleFormat, {
      style: "currency",
      currency: config.currency,
    }).format(a);
  } catch {
    return `${config.currency} ${a}`;
  }
}

/**
 * @param amount - Amount in the smallest currency unit (e.g., cents)
 */
export function formatPriceStructured(
  amount: number,
  config: CurrencyConfig
): { currency: string; unit: string; subunit: string } {
  const a = (amount / 100).toFixed(2).split(".");

  return {
    currency: getCurrencySymbol(config.currency, config.currencyLocaleFormat),
    unit: a[0],
    subunit: a[1],
  };
}
